import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import SketchColor from '../../shared/SketchColor';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 44,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    block: {
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      width: 364,
      marginRight: 8,
    },
  },
  {
    name: 'TermsBtnBackgroundColor',
  },
);

const TermsBtnBackgroundColor = ({
  termsBtnBackgroundColor,
  onColorChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {t('ecBinding:termsBtnBackgroundColor')}
      </div>
      <div className={classes.block}>
        <SketchColor
          colorHex={termsBtnBackgroundColor}
          onChange={onColorChange}
        />
      </div>
    </div>
  );
};

export default TermsBtnBackgroundColor;
